import { hasDonorName } from 'shared/utils/donorNameMatch';

export const DONOR_NAME_DETECTED_TEXT = 'Donor name detected';

export const DONOR_NAME_FLAG_VALUE = '1';

export const PROGRAM_NAME_FIELD_LABEL = 'Program name';
export const REPORT_NAME_FIELD_LABEL = 'Report name';

// Question ids are duplicated as literals on purpose: importing them from the
// report builder modules creates a require cycle that breaks module init.
export const DONOR_NAME_FIELD_LABELS: { [questionId: number]: string } = {
  1: 'Description',
  30017: 'Location notes',
  40015: 'Indicator definitions',
  50001: 'Sources and assumptions',
  50002: 'Sources and assumptions',
  110050: 'Intervention notes',
  50050: 'Impact model notes',
  60050: 'Beneficiary notes',
  60001: 'Beneficiary notes',
  70001: 'Success story',
  70002: 'Lesson learned',
  120004: 'Progress notes',
  80009: 'Budget notes',
};

export const getDonorNameFieldLabel = (
  questionId: number | undefined,
): string | undefined =>
  questionId === undefined ? undefined : DONOR_NAME_FIELD_LABELS[questionId];

export const getDonorNameFieldLabels = (
  answers: { questionId: number; text: string | null | undefined }[],
  donorName: string | null | undefined,
): string[] => {
  const labels = answers
    .filter(answer => hasDonorName(answer.text, donorName))
    .map(answer => getDonorNameFieldLabel(answer.questionId))
    .filter((label): label is string => Boolean(label));
  return Array.from(new Set(labels));
};

export const buildDonorNameWarning = (fieldLabels: string[]): string => {
  const fields = fieldLabels.length
    ? ` Fields where the name was found: ${fieldLabels.join(', ')}.`
    : '';
  return (
    'A donor name has been detected in your response. Please remove all references ' +
    'to individual donor names unless the donor has formal naming rights to the program.' +
    `${fields} If you need to retain the donor name, your report will default to private ` +
    'and not be available to share in the Impact Reporting Network.'
  );
};
